function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { tinycolor } from '@thebespokepixel/es-tinycolor';
/**
 *
 * @typedef {String} hexColor a string starting with a # followed by 6 hex characters
 */

/**
 * Adds CSS to the document
 * that defines custom CSS color variables for the given colors.
 * The variables look like --color-<name>, e.g. --color-primary-70.
 *
 * text/primary/highlight have additional color shades that are computed:
 * color (100), 90, 80, 70, 60, 50, 40, 20, 10 4.
 *
 * @param {object} [options]
 * @param {object} [options.colors] {<name>: <hex code>}
 * @param {hexColor} [options.colors.primary-70]
 * @param {hexColor} [options.colors.highlight-70]
 * @param {hexColor} [options.colors.text]
 * @param {hexColor} [options.colors.background]
 * @param {String} [options.selector] the CSS selector to wrap the variables in (default: :root)
 * @param {String} [options.styleElementSelector] A CSS selector pointing to a  <style> element (optional).
 *                         If present, the generated CSS is added to the given element.
 *                         Otherwise, a style tag is added to the document head.
 *                         This is useful when the CSS files with the default color variables
 *                         are not added to the head and the custom CSS needs to be
 *                         added to the document below the CSS files so that it actually
 *                         overrides the default colors.
 * @returns {void}
 */

export default function (options) {
  options = options || {};
  var colors = options.colors || {};
  var selector = options.selector || ':root';
  var styleTag = appendStyleTag(options.styleElementSelector);
  var colorShadeStyles = calculateColorStyles(colors);
  var adminBrandTextColorStyle;

  if (colors['admin-brand']) {
    var adminBrandTextColor = textColorForBackground(colors['admin-brand']);
    adminBrandTextColorStyle = "\n      ".concat(colorWithRgbVariants('admin-brand-text', adminBrandTextColor), ";\n    ");
  } else {
    adminBrandTextColorStyle = "\n      ".concat(rgbVariants('admin-brand-text'), ";\n    ");
  }

  styleTag.innerHTML = "\n    ".concat(selector, " {\n      ").concat(colorShadeStyles.join('\n'), "\n      --link--similar-color-text-decoration: ").concat(contrast(colors.text, colors['primary-70'] < 150) ? 'underline' : 'none', ";\n      ").concat(adminBrandTextColorStyle || '', "\n    }\n  ");
}
/**
 * @param  {String} backgroundColorName any color name that can be passes to tinycolor()
 * @return {TinyColor}
 */

function textColorForBackground(backgroundColorName) {
  var backgroundColor = tinycolor(backgroundColorName);

  if (backgroundColor.getLuminance() < 0.5) {
    return tinycolor('#fff');
  } else {
    return tinycolor('#191d2f');
  }
}

function contrast(colorName1, colorName2) {
  if (colorName1 === undefined || colorName2 === undefined) {
    return false;
  }

  var color1 = tinycolor(colorName1).toRgb();
  var color2 = tinycolor(colorName2).toRgb();
  var contrast = Math.max(color1.r, color2.r) - Math.min(color1.r, color2.r) + (Math.max(color1.g, color2.g) - Math.min(color1.g, color2.g)) + (Math.max(color1.b, color2.b) - Math.min(color1.b, color2.b));
  return contrast;
}

function appendStyleTag(existingElementSelector) {
  if (existingElementSelector) {
    var element = document.querySelector(existingElementSelector);

    if (!element) {
      throw "No element found for styleElementSelector ".concat(existingElementSelector, ".");
    }

    return element;
  }

  var styleTagId = 'cobot-assets-custom-colors';
  var styleTag = document.querySelector("head style#".concat(styleTagId)) || document.createElement('style');

  if (!styleTag.id) {
    styleTag.id = styleTagId;
    document.head.appendChild(styleTag);
  }

  return styleTag;
} // returns a tinycolor color object of the color with the given name,
// the color is taken from a css variable named --color--<name>.

/**
 * @param  {String} name one of the --color-* variable names
 * @returns {tinycolor} the current value of the given color taken from the dom
 */


function currentColor(name) {
  var el = document.createElement('span');
  el.style = "color: var(--color-".concat(name, ")");
  document.head.appendChild(el);
  var color = getComputedStyle(el).color;
  el.remove();
  return tinycolor(color);
} // returns -r/-g/-b CSS color variables for each shade of the given color (4, 10 .. 90)


function shadeRgbVariants(colorName) {
  return [null, 4, 10, 20, 40, 50, 60, 70, 80, 90].map(function (brightness) {
    var shadeName = colorName;

    if (brightness) {
      shadeName = "".concat(shadeName, "-").concat(brightness);
    }

    return rgbVariants(shadeName);
  }).join("\n");
} // returns -r/-g/-b CSS color variables for the given color
// passing a colorValue is optional. when none is passed,
// the current value within the document is determined and used.


function rgbVariants(colorName, colorValue) {
  colorValue = colorValue || currentColor(colorName);
  var rgb = colorValue.toRgb();
  return "\n    --color-".concat(colorName, "-r: ").concat(Math.round(rgb.r), ";\n    --color-").concat(colorName, "-g: ").concat(Math.round(rgb.g), ";\n    --color-").concat(colorName, "-b: ").concat(Math.round(rgb.b), ";");
}

function colorWithRgbVariants(colorName, colorValue) {
  return "\n    --color-".concat(colorName, ": ").concat(colorValue.toHex8String(), ";\n    ").concat(rgbVariants(colorName, colorValue), "\n  ");
}

function defaultColor(name) {
  return tinycolor({
    text: '#191d2f',
    background: '#ffffff',
    'primary-70': '#207abb',
    'highlight-70': '#ff1747',
    'admin-brand': '#ff1747'
  }[name]);
}

function calculateColorStyles(colors) {
  var Shades = [90, 80, 70, 60, 50, 40, 20, 10, 4];
  var Base70Shades = {
    90: -50,
    80: -25,
    60: 14.286,
    50: 28.571,
    40: 42.857,
    20: 71.429,
    10: 85.714,
    4: 94.286
  };
  return ['text', 'background', 'primary-70', 'highlight-70', 'admin-brand'].map(function (name) {
    var color = colors[name];
    var baseName = name.replace('-70', '');

    if (defaultColor(name).toHex8String() === color || color === undefined) {
      if (['primary', 'highlight', 'text'].indexOf(baseName) > -1) {
        return shadeRgbVariants(baseName);
      } else {
        return rgbVariants(baseName);
      }
    }

    var main = "--color-".concat(name, ": ").concat(color, ";");

    if (name.includes('-70')) {
      return "\n        ".concat(main, "\n        ").concat(rgbVariants(name, tinycolor(color)), "\n        ").concat(colorWithRgbVariants(baseName, brighten(color, -75)), "\n        ").concat(Object.entries(Base70Shades).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            shade = _ref2[0],
            brightenValue = _ref2[1];

        return colorWithRgbVariants("".concat(baseName, "-").concat(shade), brighten(color, brightenValue));
      }).join("\n"), "\n      ");
    } else {
      return "\n        ".concat(main, "\n        ").concat(rgbVariants(name, tinycolor(color)), "\n        ").concat(Shades.map(function (shade) {
        var brightenValue = 100 - shade;
        return colorWithRgbVariants("".concat(baseName, "-").concat(shade), brighten(color, brightenValue));
      }).join("\n"), "\n      ");
    }
  });
}
/**
 * Brightens the given color by percentage.
 * taken from SASS scale-color function (https://github.com/sass/ruby-sass/blob/1ed4e31033dd0bff4da27d1f21c531e1fdaccaab/lib/sass/script/functions.rb#L1263)
 * @param {String} colorName any color that can be passed to tinycolor()
 * @param {number} percentage by how much to brigten
 * @return {TinyColor}
 * */


function brighten(colorName, percentage) {
  if (!colorName) {
    return undefined;
  }

  var color = tinycolor(colorName);

  var _color$toHsl = color.toHsl(),
      h = _color$toHsl.h,
      s = _color$toHsl.s,
      l = _color$toHsl.l;

  var current = l;
  var scale = percentage / 100.0;
  var diff = scale > 0 ? 1.0 - current : current;
  var lNew = current + diff * scale;
  return tinycolor({
    h: h,
    s: s,
    l: lNew
  });
}